import { render, staticRenderFns } from "./EduData.vue?vue&type=template&id=5d576988&scoped=true"
import script from "./EduData.vue?vue&type=script&lang=js"
export * from "./EduData.vue?vue&type=script&lang=js"
import style0 from "./EduData.vue?vue&type=style&index=0&id=5d576988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d576988",
  null
  
)

export default component.exports